import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/services/toxicology/reach-registration-compliance-support")({
  beforeLoad: () => { throw redirect({ href: "/en/services/regulatory-toxicology/reach-registration-compliance-support", statusCode: 301 }); },
});
